import "./CampaignOverview.scss";
import { assets } from "../../assets/assets";
import React, { useContext, useEffect, useRef, useState } from "react";
import { CampaignContext } from "../../contexts/CampaignContext";
import { ToastContainer, toast } from "react-toastify";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import axios from "../../api/axios";
import {getProfilePicRoute, getCampaignFeatureVarsRoute, updateCampaignFeatureVarsRoute, getCampaignOverviewRoute, deleteCampaignUserRoute, updateCampaignRoute, updatedFeatureListRoute, addHashTagRoute, deleteHashTagRoute, updateHashTagsRoute, getStreamCustomisationVarsRoute, getCampaignCustomisationVarsRoute, getQuizzesByCampaignRoute, removeQuizRoute, getCampaignAnalyticDataRoute, setCampaignArchivedRoute, removeStreamChannelRoute, getAirTableDataRoute, makeTemplateCampaignRoute, addFeatureFromTemplateRoute, getSiteAdminTemplatesRoute } from "../../api/routes";
import { TOP_LEVEL_NAV_ROUTES } from "../../config/NavRoutes";
import { IconJsxer } from "../../helpers/IconHelper";
import { getLongDateString } from "../../helpers/Dates";
import { getRegionDataFromDbString, getRegionsDropDownListData } from "../../helpers/Regions";
import ListedCampaignUser from "../CreateCampaign/ListedCampaignUser";
import FormField from "../../components/forms/FormField/FormField";
import { ACCOUNT_TYPES } from "../../helpers/AccountTypes";
import TabbedInviteUser from "../../components/InviteUserPopup/TabbedInviteUser";
import FormDropDown from "../../components/forms/DropDownList/FormDropDown";
import RadioButtonGroup from "../../components/forms/RadioButtonGroup/RadioButtonGroup";
import { findFeature, findUnlinkedChainedFeatures, getCampaignTierFormData, chainContainsFeature } from "../../helpers/CampaignsHelper";
import AddStreamBot from "./AddStreamBot";
import BotsOverview from "./BotsOverview";
import EditStreamBot from "./EditStreamBot";
import ConfirmRemoveBot from "./ConfirmRemoveBot";
import DuplicateStreamBot from "./DuplicateStreamBot";
import EditCampaignOwner from "./EditCampaignOwner";
import AddStream from "./AddStream";
import AddStreamChannel from "./AddStreamChannel";
import StreamsOverview from "./StreamsOverview";
import ConfirmRemoveStream from "./ConfirmRemoveStream";
import ConfirmRemoveQuiz from "./ConfirmRemoveQuiz";

import EditStream from "./EditStream";
import TabbedPanel from "../../components/TabbedPanel/TabbedPanel";
import TimelineEditor from "../TimelineEditor/NodeEditor";
import CampaignDetailsTab from "./OverviewTabs/CampaignDetailsTab";
import CampaignContentTab from "./OverviewTabs/CampaignContentTab";
import CampaignStreamsTab from "./OverviewTabs/CampaignStreamsTab";
import CampaignAnalyticsTab from "./OverviewTabs/CampaignAnalyticsTab";
import AddDisruptor from "./AddDisruptor";
import AddHashtag from "./AddHashtag";

import { POST_MESSAGE_IN_TYPES, POST_MESSAGE_OUT_TYPES } from "../../helpers/FeatureControlsHelper";
import FeaturePreview, { postMessageToPreviewFrame } from "../../components/FeaturePreview/FeaturePreview";
import ConfirmRemoveFeature from "./ConfirmRemoveFeature";
import AddFeature from "./AddFeature";
import SessionAnalytics from "./SessionAnalytics";
import EditStackingOrder from "./StackingOrder/EditStackingOrder";
import ScreenRecorderPop from "../../components/ScreenRecorderPop/ScreenRecorderPop";

import { AuthContext } from "../../contexts/AuthContext";
import { TopBarContext } from "../../contexts/TopBarContext";
import StreamsDropdown from "../../components/StreamsDropdown/StreamsDropdown";
import AnalyticsDropdown from "../../components/AnalyticsDropdown/AnalyticsDropdown";
import ArcadeDataStreamsDropdown from "../../components/ArcadeData/ArcadeDataStreamsDropdown";
import CampaignDetailsPop from "../../components/Popups/CampaignDetailsPop/CampaignDetailsPop";
import EditTemplate from "../SiteAdmin/tabs/EditTemplate";
import ArcadeDataPopup from "../../components/ArcadeData/ArcadeDataPopup";
import RestrictedCustomisationPopup from "../CustomiseFeature/RestrictedCustomisationPopup";
import FunctionUnavailableInPreviewPopup from "../CustomiseFeature/themes/FunctionUnavailableInPreviewPopup";
import ConfirmationDialog from "../../components/ConfirmationDialog/ConfirmationDialog";
import LeftColorBlockBox, { LEFT_COLOR_BLOCK_STYLES } from "../../components/LeftColorBlockBox/LeftColorBlockBox";
import { CHAINS_HELPER } from "../../helpers/ChainsHelper";
import { DEFAULT_COLOURS } from "../../helpers/Colours";
import { LIVE_AUDIO_PREVIEW } from "../../helpers/LivePreviews";
import { getPreviewCustomisationVars } from "../../components/v2/CustomisationWorkspace/v2IntegrationHelpers/CampaignAndFeatureDataHelperFunctions";

const CampaignOverview = () => {
    const { id, tab } = useParams();
    const [campaignContext, setCampaignContext] = useContext(CampaignContext);
    const [topBarContext, setTopBarContext] = useContext(TopBarContext);
    const [quizzes, setQuizzes] = useState([]);
    const navigate = useNavigate();
    const location = useLocation();

    // const [updateForcer, setUpdateForcer] = useState(0);

    const [currentTab, setCurrentTab] = useState(tab === "analytics" ? 3 : tab === "details" ? 1 : tab === "streams" ? 2 : 0);
    const [currentView, setCurrentView] = useState('timeline'); // 'timeline', 'streams', 'analytics'
    const [showStreamsDropdown, setShowStreamsDropdown] = useState(false);
    const [showAnalyticsDropdown, setShowAnalyticsDropdown] = useState(false);
    const [showArcadeDataDropdown, setShowArcadeDataDropdown] = useState(false);
    const [isProducerList, setIsProducerList] = useState(true)
    const [acTypeToAdd, setAcTypeToAdd] = useState('');
    const [showInviteUserPanel, setShowInviteUserPanel] = useState(null);
    const [authContext, setAuthContext] = useContext(AuthContext);
    const [expandedSections, setExpandedSections] = useState(
        {
            details: true,
            feature: true,
            streams: true,
            analytics: true,
            disrupters: true,
            bot: true,
            producers: true,
            client: true,
            singular: true,
        }
    );

    const [gotLiveStream, setGotLiveStream] = useState(false);
    const [editMode, setEditMode] = useState(false);
    const [editedCampaignData, setEditedCampaignData] = useState(null);
    const [editedQuizzesData, setEditedQuizzesData] = useState(null);
    const [salesforceLookupMeta, setSalesforceLookupMeta] = useState({
        lastLookedUpNumber: '',
        lastLookupSucceeded: false,
    });

    const normaliseSfNumberForSave = (value) => {
        if (value === null || typeof value === 'undefined') {
            return '';
        }
        return String(value).trim();
    };

    const openEditMode = (e) => {
        e.preventDefault();
        setEditedCampaignData({ ...campaignContext.campaignData });
        setEditedQuizzesData(quizzes);
        setSalesforceLookupMeta({ lastLookedUpNumber: '', lastLookupSucceeded: false });
        setEditMode(true);
    }
    const closeEditMode = (e) => {
        e.preventDefault();
        setEditMode(false);
        setEditedCampaignData(null);
        setSalesforceLookupMeta({ lastLookedUpNumber: '', lastLookupSucceeded: false });
    }
    const changeEditedCampaignData = (field, value) => {
        editedCampaignData[field] = value;
        setEditedCampaignData({ ...editedCampaignData });
    }
    // const changeEditedQuizData = (index, field, value) => {
    //     editedQuizzesData[index][field] = value;
    //     setEditedQuizzesData(editedQuizzesData);
    // }

    const userFilters = {
        producer: [ACCOUNT_TYPES.creative.dbString, ACCOUNT_TYPES.producer.dbString, ACCOUNT_TYPES.twitchSuperUser.dbString, ACCOUNT_TYPES.koko.dbString],
        client: [ACCOUNT_TYPES.streamer.dbString, ACCOUNT_TYPES.agency.dbString, ACCOUNT_TYPES.client.dbString],
    }
    const [userFilter, setUserFilter] = useState(userFilters.client);

    const addClientContacts = (e) => {
        console.log('Add client contacts');
        setAcTypeToAdd(ACCOUNT_TYPES.client);
        setUserFilter(userFilters.client);
        setIsProducerList(false);
        setShowInviteUserPanel(true);
    }
    const removeClientContact = (e, val, i) => {
        console.log('Remove client contact: ', val, i);

        axios
            .post(deleteCampaignUserRoute, { campaignID: id, userID: val._id, withCredentials: true })
            .then((response) => {
                if (response.data.campaignData) {
                    setCampaignContext((oldValues) => {
                        return { ...oldValues, initialising: false, campaignData: response.data.campaignData }
                    })
                }
            })
            .catch(
                console.log('ERROR')
            )


    }
    const addProducers = (e) => {
        console.log('Add producers');
        setAcTypeToAdd(ACCOUNT_TYPES.producer);
        setUserFilter(userFilters.producer);
        setIsProducerList(true);
        setShowInviteUserPanel(true);
    }
    const removeProducer = (e, val, i) => {
        console.log('Remove producer: ', val, i);
        axios
            .post(deleteCampaignUserRoute, { campaignID: id, userID: val._id, withCredentials: true })
            .then((response) => {
                if (response.data.campaignData) {
                    setCampaignContext((oldValues) => {
                        return { ...oldValues, initialising: false, campaignData: response.data.campaignData }
                    })
                }
            })
    }

    const addQuiz = (e) => {
        console.log("Add quiz");
        navigate(TOP_LEVEL_NAV_ROUTES.EDIT_QUIZ, {params: {}});
    }
    const [editingQuiz, setEditingQuiz] = useState();
    const [showConfirmRemoveQuiz, setShowConfirmRemoveQuiz] = useState(false);
    const openConfirmRemoveQuiz = (quiz) => {
        console.log("Remove quiz: ",quiz);
        setEditingQuiz(quiz);
        setShowConfirmRemoveQuiz(true);
    }
    const removeQuiz = (quiz, callback) => {
        axios
            .post(removeQuizRoute, { campaignID: id, quizID: editingQuiz._id, withCredentials: true })
            .then((response) => {
                console.log("remove respone = ",response);
                if(response.data.removedQuiz) {
                    setQuizzes((oldQuizzes) => oldQuizzes.filter(it => it._id != response.data.removedQuiz.quiz._id))
                    callback(true);
                }
            })
    }
    const closeConfirmRemoveQuiz = () => {
        setEditingQuiz(null);
        setShowConfirmRemoveQuiz(false);
    }

    const closeInviteUserPanel = (e) => {
        setShowInviteUserPanel(false);
    }

    const campaignTierData = getCampaignTierFormData();

    const regionListData = getRegionsDropDownListData();
    let originalRegionData = null;
    const [currentRegion, setCurrentRegion] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const toggleExpandedSection = (section) => {
        expandedSections[section] = !expandedSections[section];
        setExpandedSections({ ...expandedSections });
    }

    const [showEditCampaignOwner, setShowEditCampaignOwner] = useState(false);
    const editCampaignOwner = (e) => {
        setShowEditCampaignOwner(true);
    }
    const closeEditCampaignOwner = (e) => {
        setShowEditCampaignOwner(false);
    }
    const changeCampaignOwner = (e, newOwner) => {
        console.log('Edit campaign owner: ', newOwner);
        changeEditedCampaignData('campaignOwnerAccount', newOwner);
    }

    // Click function ready to be implemented
    const saveEditedCampaignData = (e, repullDataAfter = true, showToast = true) => {
        console.log('Save edited campaign data: ', editedCampaignData);
        if (!isSubmitting) {
            setIsSubmitting(true);
            const clientAccountNames = Array.isArray(editedCampaignData.clientAccountNames)
                ? editedCampaignData.clientAccountNames
                    .map((value) => String(value).trim())
                    .filter(Boolean)
                : typeof editedCampaignData.clientAccountNames === 'string'
                    ? editedCampaignData.clientAccountNames
                        .split(',')
                        .map((value) => String(value).trim())
                        .filter(Boolean)
                    : (typeof editedCampaignData.client === 'string'
                        ? editedCampaignData.client
                            .split(',')
                            .map((value) => String(value).trim())
                            .filter(Boolean)
                        : []);
            const clientName = clientAccountNames.join(', ');
            const editedSfNumber = normaliseSfNumberForSave(editedCampaignData.sfNumber);
            const originalSavedSfNumber = normaliseSfNumberForSave(campaignContext.campaignData?.sfNumber);

            // Only persist Salesforce numbers that were verified by lookup.
            // If no successful lookup happened, keep the previously saved number and ignore ad-hoc input.
            let sfNumberToPersist = '';
            if (!editedSfNumber) {
                sfNumberToPersist = '';
            } else if (salesforceLookupMeta.lastLookupSucceeded && salesforceLookupMeta.lastLookedUpNumber) {
                sfNumberToPersist = salesforceLookupMeta.lastLookedUpNumber;
            } else {
                sfNumberToPersist = originalSavedSfNumber;
            }
            
            axios
                .post(updateCampaignRoute, {
                    campaignID: id,
                    campaignName: editedCampaignData.campaignName,
                    campaignTier: editedCampaignData.campaignTier,
                    selectedRegion: (currentRegion && currentRegion.value) ? currentRegion.value : (editedCampaignData?.region || campaignContext.campaignData?.region || null),
                    clientName: clientName,
                    clientAccountNames: clientAccountNames,
                    adBugCopy: editedCampaignData.adBugCopy,
                    campaignImage: editedCampaignData.campaignImage,
                    campaignOwner: editedCampaignData.campaignOwnerAccount ? editedCampaignData.campaignOwnerAccount._id : null,
                    sfLink: editedCampaignData.sfLink,
                    sfNumber: sfNumberToPersist,
                    campaignImage: editedCampaignData.campaignImage,
                    clearWatermark: editedCampaignData.clearWatermark,
                    chains: editedCampaignData.chains,
                    // features: editedCampaignData.features,
                    draft: editedCampaignData.draft,
                    isTemplate: editedCampaignData.isTemplate,
                })
                .then(function (response) {
                    setIsSubmitting(false);
                    if (showToast) {
                        toast.success("Campaign Updated!");
                    }
                    setEditMode(false);
                    
                    // Some small changes mean we can ignore any returned data which is incomplete anyway and requires a complete repull.
                    // Big changes like adding in a new feature require the repull...
                    if (repullDataAfter) {
                        setCampaignContext((oldValues) => {
                            return { ...oldValues, initialising: repullDataAfter, campaignData: response.data.campaignData }
                        })

                        pullInCampaignData();
                    }
                })
                .catch(function (error) {
                    setIsSubmitting(false);
                    toast.error('Error - ' + error.response.data.message);
                    // console.log(error.response)
                });
        }
    }

    const toggleArchived = (e) => {
        e.preventDefault();
        const newValue = editedCampaignData.archived === true ? false : true;
        axios
            .post(setCampaignArchivedRoute, {
                campaignID: id,
                setArchived: newValue,
            }).then(function (response) {
                toast.success(`Campaign ${newValue ? 'Archived' : 'Unarchived'}`);
                setEditedCampaignData({ ...editedCampaignData, archived: newValue });
                setCampaignContext((oldValues) => {
                    return { ...oldValues, initialising: false, campaignData: editedCampaignData }
                })
            })
            .catch(function (error) {
                toast.error('Error - ' + error.response.data.message);
                // console.log(error.response)
            });
    }

    const [gotAnalytics, setGotAnalytics] = useState(tab === 'analytics');
    const checkCampaignAnalyticData = () => {
        axios
        .get(getCampaignAnalyticDataRoute, {
            params: { campaignID: id },
            withCredentials:true
        })
        .then(function (response) {
            if (response.data.analyticsData) {
                setGotAnalytics(true);
            } else {
                setGotAnalytics(false);
            }
        })
        .catch(function (error) {
            setGotAnalytics(false);
        });
    }

    // TopBar navigation handlers
    const [showScreenRecorderPop, setShowScreenRecorderPop] = useState(false);
    const [showCampaignDetails, setShowCampaignDetails] = useState(false);
    const [showTemplateDetails, setShowTemplateDetails] = useState(false);
    const [campaignDetailsAnchor, setCampaignDetailsAnchor] = useState(null);
    const [currentTemplateDetails, setCurrentTemplateDetails] = useState(null);
    const [loadingTemplateDetails, setLoadingTemplateDetails] = useState(false);
    const [salesforceLookupLoading, setSalesforceLookupLoading] = useState(false);
    const [salesforceLookupResult, setSalesforceLookupResult] = useState({ isVerified: false, error: '', airtableData: null });
    
    // Close all context-managed popups  
    const closeAllPopups = () => {
        setShowStreamsDropdown(false);
        setShowAnalyticsDropdown(false);
        setShowArcadeDataDropdown(false);
        setShowInviteUserPanel(false);
        setShowScreenRecorderPop(false);
        setShowCampaignDetails(false);
        setShowTemplateDetails(false);
    };

    const loadCurrentTemplateDetails = async () => {
        const templateId = campaignContext.campaignData?.templateId;
        if (!templateId) {
            toast.error('Template details are unavailable for this campaign');
            return null;
        }

        setLoadingTemplateDetails(true);
        try {
            const response = await axios.get(getSiteAdminTemplatesRoute, { withCredentials: true });
            if (!response.data?.success || !Array.isArray(response.data.templates)) {
                throw new Error('Failed to load templates');
            }

            const matchedTemplate = response.data.templates.find((template) => template.id === templateId || template._id === templateId) || null;
            if (!matchedTemplate) {
                throw new Error('Template not found');
            }

            setCurrentTemplateDetails(matchedTemplate);
            return matchedTemplate;
        } catch (error) {
            toast.error('Failed to load template details');
            return null;
        } finally {
            setLoadingTemplateDetails(false);
        }
    };

    const openTemplateDetailsPopup = async () => {
        closeAllPopups();
        setCampaignDetailsAnchor(null);
        setShowTemplateDetails(true);

        const activeTemplateId = String(campaignContext.campaignData?.templateId || '');

        if ((currentTemplateDetails?.id || currentTemplateDetails?._id) === activeTemplateId) {
            return;
        }

        setCurrentTemplateDetails(null);

        await loadCurrentTemplateDetails();
    };

    const closeTemplateDetailsPopup = () => {
        setShowTemplateDetails(false);
        setCurrentTemplateDetails(null);
    };
    
    const handleStreamsClick = () => {
        if (!showStreamsDropdown) {
            closeAllPopups();
        }
        setShowStreamsDropdown(!showStreamsDropdown);
    };

    const handleAnalyticsClick = () => {
        if (!showAnalyticsDropdown) {
            closeAllPopups();
        }
        setShowAnalyticsDropdown(!showAnalyticsDropdown);
    };

    const handleLiveDataClick = () => {
        if (!showArcadeDataDropdown) {
            closeAllPopups();
        }
        setShowArcadeDataDropdown(!showArcadeDataDropdown);
    };

    const handleRecorderClick = () => {
        if (!showScreenRecorderPop) {
            closeAllPopups();
        }
        setShowScreenRecorderPop(!showScreenRecorderPop);
    };

    const handleAddUsersClick = () => {
        closeAllPopups();
        setShowInviteUserPanel(true);
    };

    const handleCampaignDetailsClick = (anchor) => {
        if (campaignContext.campaignData?.isTemplate) {
            openTemplateDetailsPopup();
            return;
        }

        // Toggle the campaign details popup. When opening, close other popups
        setShowCampaignDetails((prev) => {
            const opening = !prev;
            if (opening) {
                // Close other popups but don't touch campaign details state here to avoid conflicts
                setShowInviteUserPanel(false);
                setShowScreenRecorderPop(false);
                setShowStreamsDropdown(false);
                setShowAnalyticsDropdown(false);
                setShowArcadeDataDropdown(false);
            }
            return opening;
        });
        if (anchor && typeof anchor.left === 'number') {
            setCampaignDetailsAnchor(anchor);
        }
    };

    useEffect(() => {
        if (!location.state?.openTemplateDetails || !campaignContext.campaignData?.isTemplate) {
            return;
        }

        openTemplateDetailsPopup();
        navigate(location.pathname, { replace: true, state: { ...location.state, openTemplateDetails: false } });
    }, [location.state, location.pathname, campaignContext.campaignData?.isTemplate]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (!location.state?.openAnalyticsDropdown) {
            return;
        }

        closeAllPopups();
        setShowAnalyticsDropdown(true);
        navigate(location.pathname, { replace: true, state: { ...location.state, openAnalyticsDropdown: false } });
    }, [location.state, location.pathname]); // eslint-disable-line react-hooks/exhaustive-deps

    const handleTemplateDetailsSaved = (updatedTemplate) => {
        if (updatedTemplate?.id) {
            setCurrentTemplateDetails(updatedTemplate);
            toast.success('Template saved');
        }
        setShowTemplateDetails(false);
    };

    const lookupAirTable = (ioNumber) => {
        if (!ioNumber) {
            setSalesforceLookupMeta({ lastLookedUpNumber: '', lastLookupSucceeded: false });
            setSalesforceLookupResult({ isVerified: false, error: 'Please enter a Salesforce number first', airtableData: null });
            toast.error('Enter an IO number to lookup');
            return;
        }
        const normalisedIoNumber = normaliseSfNumberForSave(ioNumber);
        setSalesforceLookupMeta({
            lastLookedUpNumber: normalisedIoNumber,
            lastLookupSucceeded: false,
        });
        setSalesforceLookupLoading(true);
        setSalesforceLookupResult({ isVerified: false, error: '', airtableData: null });
        axios.get(getAirTableDataRoute, { params: { ioNumber: ioNumber }, withCredentials: true })
            .then((response) => {
                if (response.data && 
                    response.data.success && 
                    response.data.data 
                ) {
                    // && 
                    // ((Array.isArray(response.data.data.clientAccountNames) && response.data.data.clientAccountNames.length > 0) || (typeof response.data.data.clientAccountNames === 'string' || response.data.data.clientAccountNames instanceof String))) {
                    
                    const adata = response.data.data;
                    const clientAccountNames = Array.isArray(adata.clientAccountNames)
                        ? adata.clientAccountNames
                            .map((value) => String(value).trim())
                            .filter(Boolean)
                        : typeof adata.clientAccountNames === 'string'
                            ? adata.clientAccountNames
                                .split(',')
                                .map((value) => String(value).trim())
                                .filter(Boolean)
                            : [];
                    const clientName = clientAccountNames.join(', ') || ((typeof adata.clientAccountNames === 'string' && adata.clientAccountNames.trim()) ? adata.clientAccountNames.trim() : null);
                    const records = adata.records || [];
                    let country = null;
                    if (records.length > 0 && records[0].fields) {
                        country = records[0].fields['Influencer Broadcast Country'] || records[0].fields['Influencer Broadcast Country(s)'] || records[0].fields['Influencer Broadcast Country(s) '];
                    }

                    let applied = false;
                    if (clientName) {
                        try {
                            changeEditedCampaignData('client', clientName);
                            changeEditedCampaignData('clientAccountNames', clientAccountNames);
                            applied = true;
                        } catch (e) {
                            console.error('Failed to apply client to draft:', e);
                        }
                    }
                    if (country) {
                        const countryStr = String(country).toLowerCase();
                        const matched = regionListData.find(r => {
                            const label = (r.label || '').toLowerCase();
                            const db = (r.value || r.id || '').toLowerCase();
                            return label.includes(countryStr) || countryStr.includes(db) || label.includes(countryStr.split(' (')[0]);
                        });
                        if (matched) {
                            try {
                                setCurrentRegion(matched);
                                changeEditedCampaignData('region', matched.value);
                                applied = true;
                            } catch (e) {
                                console.error('Failed to apply region to draft:', e);
                            }
                        }
                    }

                    if (adata.records['streams']) {
                        setEditedCampaignData(prev => {
                            const newData = { ...prev };

                            newData.streams = [
                                ...prev.streams,
                                ...adata.records['streams']
                            ]

                            return newData;
                        })
                    }

                    if (applied) {
                        setSalesforceLookupMeta({
                            lastLookedUpNumber: normalisedIoNumber,
                            lastLookupSucceeded: true,
                        });
                        setSalesforceLookupResult({ isVerified: true, error: '', airtableData: adata });
                        setEditedCampaignData(prev => ({
                            ...prev,
                            draft: false
                        }));
                        toast.success('AirTable data applied to draft (not yet saved).');
                    } else {
                        setSalesforceLookupMeta({
                            lastLookedUpNumber: normalisedIoNumber,
                            lastLookupSucceeded: true,
                        });
                        setSalesforceLookupResult({ isVerified: false, error: 'AirTable returned data but no matching client/region could be applied.', airtableData: adata });
                        toast.info('AirTable returned data but no matching client/region could be applied.');
                    }
                } else {
                    setSalesforceLookupMeta({
                        lastLookedUpNumber: normalisedIoNumber,
                        lastLookupSucceeded: false,
                    });
                    setSalesforceLookupResult({ isVerified: false, error: 'No data found for this IO Number in AirTable', airtableData: null });
                    toast.error('No AirTable data found for that IO number');
                }
            })
            .catch((err) => {
                console.error('AirTable lookup error', err);
                setSalesforceLookupMeta({
                    lastLookedUpNumber: normalisedIoNumber,
                    lastLookupSucceeded: false,
                });
                setSalesforceLookupResult({ isVerified: false, error: 'Failed to fetch data from AirTable', airtableData: null });
                toast.error('Error fetching AirTable data');
            })
            .finally(() => {
                setSalesforceLookupLoading(false);
            });
    };

    const makeTemplateFromCampaign = () => {
        axios.post(makeTemplateCampaignRoute, { campaignID: id }, { withCredentials: true })
            .then((response) => {
                if (response.data.success) {
                    toast.success('Template created! Redirecting...');
                    navigate(`/site-admin/templates/${response.data.templateId}`);
                } else {
                    toast.error('Failed to create template');
                }
            })
            .catch((err) => {
                toast.error('Error: ' + (err.response?.data?.message || err.message));
            });
    };

    // Set up TopBar callbacks
    useEffect(() => {
        setTopBarContext({
            onStreamsClick: handleStreamsClick,
            onAnalyticsClick: handleAnalyticsClick,
            onLiveDataClick: handleLiveDataClick,
            onRecorderClick: handleRecorderClick,
            onAddUsersClick: handleAddUsersClick,
            onCampaignDetailsClick: handleCampaignDetailsClick,
            closeAllPopups: closeAllPopups,
            // Use the saved campaign name only so the top bar doesn't reflect unsaved edits
            campaignName: campaignContext.campaignData?.campaignName,
            isTemplate: campaignContext.campaignData?.isTemplate,
            templateType: campaignContext.campaignData?.templateType,
            isFeatureTemplate: campaignContext.campaignData?.templateType === 'feature',
        });
    }, [gotAnalytics, tab, campaignContext.campaignData, showStreamsDropdown, showAnalyticsDropdown, showArcadeDataDropdown]);

    const pullInCampaignData = () => {
        if (id) {
            axios
                .get(getCampaignOverviewRoute, { 
                    params: { campaignID: id }, 
                    withCredentials: true 
                })
                .then((response) => {
                    setCampaignContext((oldValues) => {
                        return { ...oldValues, initialising: false, campaignData: response.data.campaignData }
                    })

                    // console.log('Looking for current region: ', regionListData, response.data.campaignData);
                    for (let i = 0; i < regionListData.length; i++) {
                        if (regionListData[i].id === response.data.campaignData.region) {
                            originalRegionData = regionListData[i];
                            originalRegionData.index = i;
                            // console.log('Found region: ', originalRegionData);
                            break;
                        }
                    }
                    setCurrentRegion(originalRegionData);

                    // if (editMode) {
                        setEditedCampaignData({ ...response.data.campaignData });
                        checkCampaignAnalyticData();
                        const hashTagsUpdated = sanitiseHashtagData(response.data.campaignData);
                        if (!hashTagsUpdated) {
                            verifyStacking(response.data.campaignData);
                            verifyChains(response.data.campaignData);
                        }
                    // }

                    // Check for live streams
                    if (response.data.campaignData.streams) {
                        for (let i = 0; i < response.data.campaignData.streams.length; i++) {
                            if (response.data.campaignData.streams[i].status === 'live') {
                                setGotLiveStream(true);
                                break;
                            }
                        }
                    }
                })
                .catch((error) => {
                    toast.error("Error fetching campaign data");
                    navigate(TOP_LEVEL_NAV_ROUTES.CAMPAIGNS);
                });
        } else {
            navigate(TOP_LEVEL_NAV_ROUTES.CAMPAIGNS);
        }
    }

    const pullInCampaignQuizzes = () => {
        if(id) {
            axios
                .get(getQuizzesByCampaignRoute, {
                    params: {campaignID: id}, 
                    withCredentials: true
                })
                .then(response => {
                    setQuizzes(response.data.quizzes);
                    setEditedQuizzesData(response.data.quizzes);
                })
                .catch((err) => {
                    toast.error("Error fetching campaign quizzes");
                })
        } else {
            navigate(TOP_LEVEL_NAV_ROUTES.CAMPAIGNS);
        }
    }

    useEffect(() => {
        setCampaignContext((oldValues) => {
            return { ...oldValues, initialising: true }
        });
        pullInCampaignData();
        pullInCampaignQuizzes();
        /*
        if (campaignContext.campaignData && campaignContext.campaignData._id === id) {
            // we already have our campaign data available!
            setCampaignContext((oldValues) => {
                return { ...oldValues, initialising: false }
            });
            setTimeout(pullInCampaignData, 20);
        } else {
            setCampaignContext((oldValues) => {
                return { ...oldValues, initialising: true }
            });
            setTimeout(pullInCampaignData, 20);
        }*/
    }, []);

    const [editingBot, setEditingBot] = useState();
    const [showEditBot, setShowEditBot] = useState(false);
    const editBot = (bot) => {
        setEditingBot(bot);
        setShowEditBot(true);
    }
    const closeEditBot = () => {
        setShowEditBot(false);
    }
    const [showRemoveBot, setShowRemoveBot] = useState(false);
    const removeBot = (bot) => {
        setEditingBot(bot);
        setShowRemoveBot(true);
    }
    const closeRemoveBot = () => {
        setShowRemoveBot(false);
    }
    const [showDuplicateBot, setShowDuplicateBot] = useState(false);
    const duplicateBot = (bot) => {
        setEditingBot(bot);
        setShowDuplicateBot(true);
    }
    const closeDuplicateBot = () => {
        setShowDuplicateBot(false);
    }
    const [showAddStreamBot, setShowAddStreamBot] = useState(false);

    
    const addStreamBot = (e) => {
        setShowAddStreamBot(true);
    }
    const closeAddStreamBot = (e) => {
        setShowAddStreamBot(false);
    }

    const [showAddStreamChannel, setShowAddStreamChannel] = useState(false);
    const [addChannelStreamID, setAddChannelStreamID] = useState(null);
    const addStreamChannel = (e, streamID) => {
        setAddChannelStreamID(streamID)
        setShowAddStreamChannel(true);
    }
    const closeAddStreamChannel = (e) => {
        setShowAddStreamChannel(false);
    }

    const [showAddStream, setShowAddStream] = useState(false);
    const addStream = (e) => {
        setShowAddStream(true);
    }
    const closeAddStream = (e) => {
        setShowAddStream(false);
    }
    const [editingStream, setEditingStream] = useState();
    const [showEditStream, setShowEditStream] = useState(false);
    const editStream = (stream) => {
        setEditingStream(stream);
        setShowEditStream(true);
    }
    const closeEditStream = () => {
        setShowEditStream(false);
        setEditingStream(null);
    }
    const [showRemoveStream, setShowRemoveStream] = useState(false);
    const removeStream = (stream) => {
        setEditingStream(stream);
        setShowRemoveStream(true);
    }
    const closeRemoveStream = () => {
        setShowRemoveStream(false);
    }

    const [showAddDistruptor, setShowAddDistruptor] = useState(false);
    const [addingIntro, setAddingIntro] = useState(false);
    const [addingOutro, setAddingOutro] = useState(false);
    const addDisruptorToStartOfChain = useRef(null);
    const addDisruptor = (e = null, intro = false, outro = false, chain = null) => {
        setAddingIntro(intro);
        setAddingOutro(outro);
        currentChainRef.current = chain;
        setShowAddDistruptor(true);
    };
    const closeAddDisruptor = () => {setShowAddDistruptor(false)};

    const setIntroAsOutro = (toggleOn, chain) => {
        if (chain.length > 1 && chain[0] !== chain[1]) {
            if (toggleOn) {
                chain[2] = chain[0];
            } else {
                if (chain.length === 3) {
                    chain.pop();
                }
            }
            saveEditedCampaignData();
        }
    }

    const changeChainOrder = (chainItem, chain, dir = 1) => {
        if ( 
            (dir === 1 && chain.indexOf(chainItem) < chain.length - 1)
            || (dir === -1 && chain.indexOf(chainItem) > 0)
        ) {
            const index = chain.indexOf(chainItem);
            const indexSwap = index + dir;
            const itemSwappingWith = chain[indexSwap];
            chain[index] = itemSwappingWith;
            chain[indexSwap] = chainItem;
            saveEditedCampaignData(null, false, false);
        }
    }

    const duplicatedChainedFeature = (index, chain) => {
        // const index = chain.indexOf(featureId);
        if (index > -1) {
            const data = chain[index];
            chain.splice(index, 0, data);
            saveEditedCampaignData(null, false, false);
        }
    }

    const removeFeatureFromChain = (index, chain) => {
        if (index > -1) {
            chain.splice(index, 1);
            // if (chain.indexOf(featureId) === -1) {
                // We need to completely remove this feature
                // removeSelectedFeatureFromList(featureData);
            // } else {
                // Just assume it's a dupe! It might be in use elsewhere - we will cleanup later.
                saveEditedCampaignData(null, false, false);
            // }
        }
    }

    const removeChannelFromStream = (streamID, channel) => {
       console.log('REMOVE CHANNEL FROM STREAM', streamID, channel)

/*
       campaignID
       streamID,
       twitchHandle
*/

        // channel can be a string (legacy) or a channel object
        const isAmazon = typeof channel === 'object' ? Boolean(channel.isAmazon) : false;
        const payload = {
            campaignID: id,
            streamID,
        };
        if (isAmazon) {
            payload.amazonBroadcastId = channel.amazonBroadcastId;
        } else {
            payload.twitchHandle = typeof channel === 'string' ? channel : channel.twitchHandle;
        }

        axios
        .post(removeStreamChannelRoute, payload)
        .then(function (response) {
            const label = isAmazon ? `Amazon Live - ${payload.amazonBroadcastId}` : (payload.twitchHandle || 'channel');
            toast.success("Channel "+label+" Removed From Stream");
            setCampaignContext((oldValues) => {
                return { ...oldValues, initialising: true, campaignData: response.data.campaignData }
            })

            pullInCampaignData();
    })
      
    }

    const getProfilePic = (twitchHandle, callback) => {
        console.log('Get Profile Pic for:', twitchHandle)
        axios
        .get(getProfilePicRoute, {
            params: {    twitchHandle: twitchHandle },
            withCredentials:true
          
        })
        .then((response) => {
            if (response.data && response.data.profilePic) {
                if (callback) callback(response.data.profilePic);
            } else {
                if (callback) callback(null);
            }
        })
        .catch((error) => {
            console.error('Error fetching profile pic:', error);
            if (callback) callback(null);
        })
    }

    const [showAddFeature, setShowAddFeature] = useState(false);
    const addFeature = () => {setShowAddFeature(true)};
    const closeAddFeature = () => {setShowAddFeature(false)};

    const addFeatureFromTemplate = (templateId, completedCallback) => {
        axios.post(addFeatureFromTemplateRoute, { campaignId: id, templateId }, { withCredentials: true })
            .then(res => {
                toast.success('Template applied!');
                setCampaignContext(old => ({ ...old, initialising: true }));
                pullInCampaignData();
                getFeatureVars();
                if (completedCallback) completedCallback(true);
            })
            .catch(err => {
                toast.error('Failed to apply template');
                if (completedCallback) completedCallback(false);
            });
    };

    const lastFeatureAddedLabelRef = useRef(null);
    const lastFeatureIdRef = useRef(null);

    const addSelectedFeatureToList = (newFeatureData, completedCallback, addToStartOfChain = null) => {
        console.log('Add feature to list: ', newFeatureData, editedCampaignData.features);
        lastFeatureAddedLabelRef.current = newFeatureData.contentLabel;
        lastFeatureIdRef.current = newFeatureData.feature._id;
        newFeatureData.feature.commands = [];
        const featureList = editedCampaignData.features;
        featureList.push(newFeatureData);
        changeEditedCampaignData('features', featureList);
        addDisruptorToStartOfChain.current = addToStartOfChain;

        const featureData = [];
        for (let i = 0; i < editedCampaignData.features.length; i++) {
            // const chained = (i === editedCampaignData.features.length - 1) && (addingIntro || addingOutro);
            const oneFeature = {
                _id: editedCampaignData.features[i]._id, 
                feature: editedCampaignData.features[i].feature._id, 
                contentLabel: editedCampaignData.features[i].contentLabel || editedCampaignData.features[i].feature.featureName, 
                varKey:editedCampaignData.features[i].varKey,
                countIn:editedCampaignData.features[i].countIn || false,
                countInTime:editedCampaignData.features[i].countInTime || 10,
                isChained:false, // chained || editedCampaignData.features[i].isChained || false,
                stackingOrder: editedCampaignData.features[i].stackingOrder,
            };
            featureData.push(oneFeature);
        }
        console.log('Sending update: ', featureData);
        
        axios
        .post(updatedFeatureListRoute, {
            campaignID: id,
            features: featureData,
            addingFeature: true,
        })
        .then(function (response) {
            toast.success("Campaign Updated!");

            setCampaignContext((oldValues) => {
                return { ...oldValues, initialising: true }
            });
            pullInCampaignData();
            getFeatureVars();

            if (completedCallback) {
                completedCallback(true);
            }
        })
        .catch(function (error) {
            featureList.pop();
            changeEditedCampaignData('features', featureList);

            if (completedCallback) {
                completedCallback(false);
            }
            toast.error('Error - ' + error.response.data.message);
            // console.log(error.response)
        });
    }

    const saveFeatureUpdates = () => {
        const featureData = [];
        for (let i = 0; i < editedCampaignData.features.length; i++) {
            const oneFeature = {
                _id: editedCampaignData.features[i]._id,
                feature: editedCampaignData.features[i].feature._id,
                contentLabel: editedCampaignData.features[i].contentLabel || editedCampaignData.features[i].feature.featureName,
                varKey: editedCampaignData.features[i].varKey,
                countIn: editedCampaignData.features[i].countIn || false,
                countInTime: editedCampaignData.features[i].countInTime || 10,
                isChained: editedCampaignData.features[i].isChained || false,
                stackingOrder: editedCampaignData.features[i].stackingOrder,
            };
            featureData.push(oneFeature);
        }

        changeEditedCampaignData('features', editedCampaignData.features);

        axios
            .post(updatedFeatureListRoute, {
                campaignID: id,
                features: featureData,
            }) 
            .then(function (response) {
                toast.success("Changes Saved!");
            })
            .catch(function (error) {
                toast.error('Error - ' + error.response.data.message);
            })
    }

    const [showConfirmRemoveFeature, setShowConfirmRemoveFeature] = useState(false);
    const removeFeature = (featureToRemoveData, chain = null) => {
        currentFeatureRef.current = featureToRemoveData;
        currentChainRef.current = chain;
        setCurrentFeature(featureToRemoveData);
        setShowConfirmRemoveFeature(true);
    }
    const closeConfirmRemoveFeature = () => {
        setShowConfirmRemoveFeature(false);
    }

    const removeSelectedFeatureFromList = (featureToRemoveData, completedCallback) => {
        console.log('Remove feature from list: ', featureToRemoveData, editedCampaignData.features);

        const featureList = editedCampaignData.features;
        // featureList.push(featureToRemoveData);
        const featureIndex = featureList.indexOf(featureToRemoveData);
        if (featureIndex >= 0) {
            featureList.splice(featureIndex, 1);
        }
        changeEditedCampaignData('features', featureList);

        const featureData = [];
        for (let i = 0; i < editedCampaignData.features.length; i++) {
            const oneFeature = {
                _id: editedCampaignData.features[i]._id, 
                feature: editedCampaignData.features[i].feature._id, 
                contentLabel: editedCampaignData.features[i].contentLabel || editedCampaignData.features[i].feature.featureName, 
                varKey:editedCampaignData.features[i].varKey,
                countIn: editedCampaignData.features[i].countIn,
                countInTime: editedCampaignData.features[i].countInTime,
                isChained: editedCampaignData.features[i].isChained || false,
                stackingOrder: editedCampaignData.features[i].stackingOrder,
            };
            featureData.push(oneFeature);
        }
        console.log('Sending update: ', featureData);
        
        axios
        .post(updatedFeatureListRoute, {
            campaignID: id,
            features: featureData,
        })
        .then(function (response) {
            if (completedCallback) {
                completedCallback(true);
            } else {
                toast.success("Campaign Updated!");
            }
        })
        .catch(function (error) {
            featureList.push(featureToRemoveData);
            changeEditedCampaignData('features', featureList);

            if (completedCallback) {
                completedCallback(false);
            }
            toast.error('Error - ' + error.response.data.message);
            // console.log(error.response)
        });
    }

    const removeUnlinkedChainedFeatures = (campaignData, customisationData) => {
        if (addingIntro || addingOutro) {
            return;
        }
        const featuresToRemoveIdList = findUnlinkedChainedFeatures(campaignData, customisationData.current);

        if (featuresToRemoveIdList.length > 0) {
            const featureList = campaignData.features;
            for (let i = featureList.length - 1; i >= 0; i--) {
                if (featuresToRemoveIdList.indexOf(featureList[i]._id) >= 0) {
                    featureList.splice(i, 1);
                }
            }
            changeEditedCampaignData('features', featureList);

            const featureData = [];
            for (let i = 0; i < campaignData.features.length; i++) {
                const oneFeature = {
                    _id: campaignData.features[i]._id, 
                    feature: campaignData.features[i].feature._id, 
                    contentLabel: campaignData.features[i].contentLabel || campaignData.features[i].feature.featureName, 
                    varKey:campaignData.features[i].varKey,
                    countIn: campaignData.features[i].countIn,
                    countInTime: campaignData.features[i].countInTime,
                    isChained: campaignData.features[i].isChained || false,
                    stackingOrder: editedCampaignData.features[i].stackingOrder,
                };
                featureData.push(oneFeature);
            }
            console.log('Sending update (removed features): ', featuresToRemoveIdList, featureData);
            
            axios
            .post(updatedFeatureListRoute, {
                campaignID: id,
                features: featureData,
            })
            .then(function (response) {
                // We'll just do this silently!
            })
            .catch(function (error) {
                // console.log(error.response)
            });
        }
    }

    const findFeatureChain = (featureId) => {
        if (editedCampaignData && editedCampaignData.chains) {
            for (let i = 0; i < editedCampaignData.chains.length; i++) {
                if (chainContainsFeature(editedCampaignData.chains[i], featureId)) {
                    return editedCampaignData.chains[i];
                }
            }
        }
        return null;
    }

    const [showEditStacking, setShowEditStacking] = useState(false);
    const editStacking = () => {setShowEditStacking(true)};
    const closeEditStacking = () => {setShowEditStacking(false)};

    const [showAddHashtag, setShowAddHashtag] = useState(false);
    const editingFeature = useRef(null);
    const addHashtag = (feature) => {editingFeature.current = feature; setShowAddHashtag(true)};
    const closeAddHashtag = () => {setShowAddHashtag(false)};
    const saveHashtag = (hashtagData, completedCallback) => {
        console.log('Save hashtag: ', hashtagData);

        const commandList = editedCampaignData.hashtagCommands;
        let found = false;
        for (let i = 0; i < commandList.length; i++) {
            if (commandList[i].command === hashtagData.command && commandList[i].featureID === hashtagData.featureID && commandList[i].param === hashtagData.param) {
                commandList[i].hashtags.push(hashtagData.hashtag);
                found = true;
                break;
            }
        }
        if (!found) {
            const newCommand = {
                command: hashtagData.command,
                featureID: hashtagData.featureID,
                hashtags: [hashtagData.hashtag],
                param: hashtagData.param,
                commandParam: hashtagData.commandParam,
            }
            commandList.push(newCommand);
        }
        changeEditedCampaignData('hashtagCommands', commandList);
        
        axios
        .post(addHashTagRoute, hashtagData)
        .then(function (response) {
            toast.success("Campaign Updated!");
            if (completedCallback) {
                completedCallback(true);
            }
        })
        .catch(function (error) {
            for (let i = 0; i < commandList.length; i++) {
                if (commandList[i].command === hashtagData.command && commandList[i].featureID === hashtagData.featureID && commandList[i].param === hashtagData.param) {
                    commandList[i].hashtags.pop();
                    break;
                }
            }
            changeEditedCampaignData('hashtagCommands', commandList);

            if (completedCallback) {
                completedCallback(false);
            }
            toast.error('Error - ' + error.response.data.message);
            // console.log(error.response)
        });
    }
    const removeHashtag = (removeData) => {
        console.log('Remove hashtag: ', removeData);
        axios
        .post(deleteHashTagRoute, removeData)
        .then(function (response) {
            toast.success("Campaign Updated!");
            const commandList = editedCampaignData.hashtagCommands;
            for (let i = 0; i < commandList.length; i++) {
                if (commandList[i].command === removeData.command && commandList[i].featureID === removeData.featureID && commandList[i].param === removeData.param) {
                    console.log('Remove hashtag from command: ', commandList[i], commandList[i].hashtags, removeData.hashtag, commandList[i].hashtags.indexOf(removeData.hashtag));
                    while (commandList[i].hashtags.indexOf(removeData.hashtag) >= 0) {
                        commandList[i].hashtags.splice(commandList[i].hashtags.indexOf(removeData.hashtag), 1);
                    }
                }
            }
            changeEditedCampaignData('hashtagCommands', commandList);
        })
        .catch(function (error) {
            toast.error('Error - ' + error.response.data.message);
            // console.log(error.response)
        });
    }

    // Make sure our hashtag data makes sense, eg. we are going to have a cooldown, not just a hashtag string + feature ids might need to be corrected.
    // We should remove this at some point, ie when we are happy all the data is correct.
    // It probably shouldn't find it's way into the live build..?
    const sanitiseHashtagData = (campaignData) => {
        const commandList = campaignData.hashtagCommands;
        if (!commandList) return false;
        let changesHaveBeenMade = false;
        const hashtagIndexsForRemoval = [];
        for (let i = 0; i < commandList.length; i++) {
            for (let j = 0; j < commandList[i].hashtags.length; j++) {
                // Fix old string based hashtags...
                if (typeof commandList[i].hashtags[j] === 'string') {
                    // Old data!
                    const newData = {hashtag: commandList[i].hashtags[j], cooldown: 0};
                    commandList[i].hashtags[j] = newData;
                    changesHaveBeenMade = true;
                }
                // Fix feature ids... Can result in some features losing hashtags, but this is only a temporary measure.
                for (let k = campaignData.features.length - 1; k >= 0; k--) {
                    if (campaignData.features[k].feature && campaignData.features[k].feature._id === commandList[i].featureID) {
                        // This is intended for this feature, but has the wrong id!
                        // Let's correct that!
                        commandList[i].featureID = campaignData.features[k]._id;
                        changesHaveBeenMade = true;
                        // This is first come first served + it won't match any others now, so let's break!
                        break;
                    }
                }
                // Now check if this hashtag is related to an old feature (ie. one that has been removed)
                let found = false;
                for (let k = 0; k < campaignData.features.length; k++) {
                    if (campaignData.features[k]._id === commandList[i].featureID) {
                        found = true;
                        break;
                    }
                }
                if (!found) {
                    // This feature has been removed!
                    hashtagIndexsForRemoval.push(i);
                }
            }
        }

        // Now let's check if we have any hashtags that are copies of other hashtags...
        for (let i = commandList.length - 1; i >= 0; i--) {
            if (hashtagIndexsForRemoval.indexOf(i) === -1) {
                const jsonedHashtagData = JSON.stringify(commandList[i].hashtags);
                for (let j = i - 1; j >= 0; j--) {
                    if (commandList[i].command === commandList[j].command && commandList[i].featureID === commandList[j].featureID && jsonedHashtagData === JSON.stringify(commandList[j].hashtags)) {
                        hashtagIndexsForRemoval.push(i);
                        break;
                    }
                }
            }
        }

        // Splice out these hashtags...
        for (let i = hashtagIndexsForRemoval.length - 1; i >= 0; i--) {
            commandList.splice(hashtagIndexsForRemoval[i], 1);
            changesHaveBeenMade = true;
        }

        if (changesHaveBeenMade) {
            // Send the updated data back to the server!
            axios
                .post(updateHashTagsRoute, {
                    campaignID: id,
                    hashtagCommands: commandList,
                })
                .then(function (response) {
                    pullInCampaignData();
                })
                .catch(function (error) {
                    toast.error('Error - ' + error.response.data.message);
                    // console.log(error.response)
                });
        }
        return changesHaveBeenMade;
    }

    // Verify our chains, as above, we should remove this at some point as I'm only adding it now while I add in the chains functionality.
    // Newly created campaign should have valid data already..?
    const attemptsToUpdateChainCount = useRef(0);
    const MAX_ATTEMPTS_TO_UPDATE_CHAIN = 20;
    const verifyChains = (campaignData) => {
        // let featureChainIndex = 0;
        let verifiedFeatureChains = [];
        let madeChanges = false;
        // let featuresUpdated = false;
        let chainToModify = null;

        // Make a copy of our chains so we can verify them and find the one we are going to modify if we are adding a disruptor to a chain.
        for (let i = 0; i < campaignData.chains.length; i++) {
            verifiedFeatureChains.push([]);
            let thisIsOurSelectedChain = currentChainRef.current ? true : false;
            if (campaignData.chains[i].length > 0) {
                for (let j = 0; j < campaignData.chains[i].length; j++) {
                    verifiedFeatureChains[i].push(campaignData.chains[i][j]);
                    if (currentChainRef.current) {
                        if (campaignData.chains[i][j] !== currentChainRef.current[j]) {
                            thisIsOurSelectedChain = false;
                        }
                    }
                }
                if (thisIsOurSelectedChain) {
                    chainToModify = verifiedFeatureChains[i];
                }
            }
        }

        // Are we adding an intro?
        if (addingIntro && addDisruptorToStartOfChain.current === true) {
            if (chainToModify) {
                // We need to make sure we have the latest updated feature id avilable before we add it to out chain.
                // Due to async there is a possibility that the data we pull in doesn't have the feature added yet, if not we will wait a bit and try again.
                if (campaignData.features[campaignData.features.length - 1].contentLabel === lastFeatureAddedLabelRef.current && campaignData.features[campaignData.features.length - 1].feature._id === lastFeatureIdRef.current) {
                    chainToModify.splice(0, 0, `${campaignData.features[campaignData.features.length - 1]._id}:${CHAINS_HELPER.START_TYPE_AUTO}:0:${CHAINS_HELPER.END_TYPE_FEATURE_END}`);
                    madeChanges = true;
                    console.log('Added intro to chain: ', chainToModify, campaignData.features[campaignData.features.length - 1]._id);
                }
            }
        }

        // Are we adding an outro?
        if (addingOutro && addDisruptorToStartOfChain.current === false) {
            // is this the feature we want to add an outro to?
            if (chainToModify) {
                // We need to make sure we have the latest updated feature id avilable before we add it to out chain.
                // Due to async there is a possibility that the data we pull in doesn't have the feature added yet, if not we will wait a bit and try again.
                if (campaignData.features[campaignData.features.length - 1].contentLabel === lastFeatureAddedLabelRef.current && campaignData.features[campaignData.features.length - 1].feature._id === lastFeatureIdRef.current) {
                    chainToModify.push(`${campaignData.features[campaignData.features.length - 1]._id}:${CHAINS_HELPER.START_TYPE_AUTO}:0:${CHAINS_HELPER.END_TYPE_FEATURE_END}`);
                    madeChanges = true;
                    console.log('Added outro to chain: ', chainToModify, campaignData.features[campaignData.features.length - 1]._id);
                }
            }
        }

        if (((addingIntro || addingOutro) && (madeChanges || attemptsToUpdateChainCount.current >= MAX_ATTEMPTS_TO_UPDATE_CHAIN)) || (!addingIntro && !addingOutro)) {
            currentChainRef.current = null;
            setAddingIntro(false);
            setAddingOutro(false);
            addDisruptorToStartOfChain.current = null;
            attemptsToUpdateChainCount.current = 0;
        } else {
            attemptsToUpdateChainCount.current++;
            console.log('Failed to add feature to chain - data not ready yet!', attemptsToUpdateChainCount.current);
            setTimeout(() => {
                pullInCampaignData();
            }, 200);
            return;
        }

        /* for (let i = 0; i < campaignData.features.length; i++) {
            if (campaignData.features[i].feature.featureType === 'feature') {
                // We have a feature!
                // Do we have a chain for it?
                let featureChain = null;
                for (let j = 0; j < campaignData.chains.length; j++) {
                    if (campaignData.chains[j].indexOf(campaignData.features[i]._id) >= 0) {
                        // We have a chain!
                        if (featureChain === null) {
                            featureChain = campaignData.chains[j];
                            if (j !== featureChainIndex) {
                                madeChanges = true;
                            }
                            verifiedFeatureChains[featureChainIndex] = featureChain;
                        } else {
                            // We can't have the same feature in more than one chain!
                            madeChanges = true;
                        }
                    }
                }
                if (featureChain === null) {
                    madeChanges = true;
                    featureChain = [campaignData.features[i]._id];
                    verifiedFeatureChains[featureChainIndex] = featureChain;
                }
                if (typeof campaignData.features[i].countIn === 'undefined') {
                    campaignData.features[i].countIn = false;
                    campaignData.features[i].countInTime = 10;
                    featuresUpdated = true;
                    madeChanges = true;
                }

                // Are we adding an intro?
                if (addingIntro && addDisruptorToStartOfChain.current === true) {
                    // is this the feature we want to add an intro to?
                    if (currentChainRef.current && currentChainRef.current.indexOf(campaignData.features[i]._id) >= 0) {
                        // Yes, this is the right one!
                        // is the first id in the chain the latest added feature?
                        if (campaignData.features[campaignData.features.length - 1].feature.featureType !== 'feature' && campaignData.features[campaignData.features.length - 1].feature.contentLabel === lastFeatureAddedLabelRef.current && campaignData.features[campaignData.features.length - 1].feature._id === lastFeatureIdRef.current) {
                            featureChain.splice(0, 0, campaignData.features[campaignData.features.length - 1]._id);
                            madeChanges = true;
                        }
                    }
                }

                // Are we adding an outro?
                // This should be easier...?
                if (addingOutro && addDisruptorToStartOfChain.current === false) {
                    // is this the feature we want to add an outro to?
                    if (currentChainRef.current && currentChainRef.current.indexOf(campaignData.features[i]._id) >= 0) {
                        // Yes, this is the right one!
                        // is the last id in the chain the latest added feature?
                        if (campaignData.features[campaignData.features.length - 1].feature.featureType !== 'feature' && campaignData.features[campaignData.features.length - 1].contentLabel === lastFeatureAddedLabelRef.current && campaignData.features[campaignData.features.length - 1].feature._id === lastFeatureIdRef.current) {
                            featureChain.push(campaignData.features[campaignData.features.length - 1]._id);
                            madeChanges = true;
                        }
                    }
                }

                if (((addingIntro || addingOutro) && (madeChanges || attemptsToUpdateChainCount.current >= MAX_ATTEMPTS_TO_UPDATE_CHAIN)) || (!addingIntro && !addingOutro)) {
                    currentChainRef.current = null;
                    setAddingIntro(false);
                    setAddingOutro(false);
                    addDisruptorToStartOfChain.current = null;
                    attemptsToUpdateChainCount.current = 0;
                } else {
                    attemptsToUpdateChainCount.current++;
                    console.log('Failed to add feature to chain - data not ready yet!', attemptsToUpdateChainCount.current);
                    setTimeout(() => {
                        pullInCampaignData();
                    }, 200);
                    return;
                }
            }
        } */


        // Make sure our chains only contain valid feature Ids
        for (let i = 0; i < verifiedFeatureChains.length; i++) {
            for (let j = verifiedFeatureChains[i].length - 1; j >= 0; j--) {
                let found = false;
                
                // Get the feature ID from either string or object format
                let chainFeatureId;
                const chainItem = verifiedFeatureChains[i][j];
                if (typeof chainItem === 'string') {
                    chainFeatureId = chainItem.split(':')[0];
                } else if (typeof chainItem === 'object' && chainItem.featureId) {
                    chainFeatureId = chainItem.featureId;
                } else {
                    // Invalid format, remove it
                    verifiedFeatureChains[i].splice(j, 1);
                    madeChanges = true;
                    continue;
                }
                
                for (let k = 0; k < campaignData.features.length; k++) {
                    if (campaignData.features[k]._id === chainFeatureId) {
                        found = true;
                        break;
                    }
                }
                if (!found) {
                    verifiedFeatureChains[i].splice(j, 1);
                    madeChanges = true;
                } else {
                    // Only validate string format (objects are already validated by the timeline editor)
                    if (typeof chainItem === 'string') {
                        // Make sure we have all the extra param data
                        const chainItemDataSplit = chainItem.split(':');
                        if (chainItemDataSplit.length === 1) {
                            chainItemDataSplit.push('auto');
                            madeChanges = true;
                        }
                        if (chainItemDataSplit[1] !== 'auto' && chainItemDataSplit[1] !== 'manual') {
                            chainItemDataSplit[1] = 'auto';
                            madeChanges = true;
                        }
                        if (chainItemDataSplit.length === 2) {
                            chainItemDataSplit.push(0);
                            madeChanges = true;
                        }
                        if (isNaN(chainItemDataSplit[2])) {
                            chainItemDataSplit[2] = 0;
                            madeChanges = true;
                        }
                        if (chainItemDataSplit.length === 3) {
                            chainItemDataSplit.push('feature_end');
                            madeChanges = true;
                        }
                        if (chainItemDataSplit[3] !== 'feature_end' && chainItemDataSplit[3] !== 'immediate') {
                            chainItemDataSplit[3] = 'feature_end';
                            madeChanges = true;
                        }
                        while (chainItemDataSplit.length > 4) {
                            chainItemDataSplit.pop();
                            madeChanges = true;
                        }

                        // If this is the last item in the change, make sure it is set to end when the feature ends.
                        if (j === verifiedFeatureChains[i].length - 1) {
                            if (chainItemDataSplit[3] !== 'feature_end') {
                                chainItemDataSplit[3] = 'feature_end';
                                madeChanges = true;
                            }
                        }
                        verifiedFeatureChains[i][j] = chainItemDataSplit.join(':');
                    }
                    // Object format doesn't need validation here - it's managed by the timeline editor
                }
            }
        }
        if (verifiedFeatureChains.length !== campaignData.chains.length) {
            madeChanges = true;
        }
        if (madeChanges) {
            campaignData.chains = verifiedFeatureChains;
            // Send the update up to the server!
            console.log('Saving chain / count in changes!', campaignData);
            // changeEditedCampaignData('chains', campaignData.chains);
            // if (featuresUpdated) {
                // changeEditedCampaignData('features', campaignData.features);
            // }
            // saveEditedCampaignData(null);

            // secretly save our changes!
            axios
            .post(updateCampaignRoute, {
                campaignID: id,
                campaignName: campaignData.campaignName,
                campaignTier: campaignData.campaignTier,
                selectedRegion: campaignData.region,
                clientName: campaignData.client,
                adBugCopy: campaignData.adBugCopy,
                campaignOwner: campaignData.campaignOwnerAccount? campaignData.campaignOwnerAccount._id : null,
                sfLink: campaignData.sfLink,
                sfNumber: campaignData.sfNumber,
                chains: campaignData.chains,
            })

            /* if (featuresUpdated) {
                const featureData = [];
                for (let i = 0; i < campaignData.features.length; i++) {
                    const oneFeature = {
                        _id: campaignData.features[i]._id, 
                        feature: campaignData.features[i].feature._id, 
                        contentLabel: campaignData.features[i].contentLabel || campaignData.features[i].feature.featureName, 
                        varKey:campaignData.features[i].varKey,
                        countIn:campaignData.features[i].countIn || false,
                        countInTime:campaignData.features[i].countInTime || 10,
                        stackingOrder: editedCampaignData.features[i].stackingOrder,
                    };
                    featureData.push(oneFeature);
                }
                console.log('Sending updated feature data: ', featureData);
                
                axios
                .post(updatedFeatureListRoute, {
                    campaignID: id,
                    features: featureData,
                })
            } */

            setEditedCampaignData({ ...campaignData });
        }

        // We'll reset these just in case - at least if something has gone wrong it won't have a knock on effect
        setAddingIntro(false);
        setAddingOutro(false);
        currentChainRef.current = null;

        return madeChanges;
    }

    const changeFeatureChainItemSetting = (chain, chainItemIndex, paramIndex, newValue) => {
        // Set the value of the specified chain item to the new value.
        // This is used for setting the start type, start delay and end type of a chain item.
        // Handles both string format ({featureId}:{startType}:{startDelay}:{endType})
        // and object format ({ featureId, startType, startDelay, endType, ... })
        const originalChainItemData = chain[chainItemIndex];
        const parsedItem = CHAINS_HELPER.parseChainItem(originalChainItemData);
        
        // Determine which property to update
        let propToUpdate = null;
        if (paramIndex === CHAINS_HELPER.PARAM_INDEXES.FEATURE_ID) {
            return; // Can't change feature ID
        } else if (paramIndex === CHAINS_HELPER.PARAM_INDEXES.START_TYPE) {
            if (newValue !== CHAINS_HELPER.START_TYPE_AUTO && newValue !== CHAINS_HELPER.START_TYPE_MANUAL) {
                return;
            }
            propToUpdate = 'startType';
        } else if (paramIndex === CHAINS_HELPER.PARAM_INDEXES.START_DELAY) {
            if (isNaN(newValue)) {
                return;
            }
            propToUpdate = 'startDelay';
        } else if (paramIndex === CHAINS_HELPER.PARAM_INDEXES.END_TYPE) {
            if (newValue !== CHAINS_HELPER.END_TYPE_FEATURE_END && newValue !== CHAINS_HELPER.END_TYPE_IMMEDIATE) {
                return;
            }
            propToUpdate = 'endType';
        }
        
        if (!propToUpdate || parsedItem[propToUpdate] === newValue) {
            return;
        }
        
        // Update the value
        parsedItem[propToUpdate] = newValue;
        
        // Serialize back to the appropriate format
        chain[chainItemIndex] = CHAINS_HELPER.serializeChainItem(parsedItem);
        // Now we need to save the updated chain to the campaign data.
        const campaignData = editedCampaignData;
        campaignData.chains[currentChainRef.currentIndex] = chain;
        // Save the updated campaign data to the server.
        axios
        .post(updateCampaignRoute, {
            campaignID: id,
            campaignName: campaignData.campaignName,
            campaignTier: campaignData.campaignTier,
            selectedRegion: campaignData.region,
            clientName: campaignData.client,
            adBugCopy: campaignData.adBugCopy,
            campaignOwner: campaignData.campaignOwnerAccount? campaignData.campaignOwnerAccount._id : null,
            sfLink: campaignData.sfLink,
            sfNumber: campaignData.sfNumber,
            chains: campaignData.chains,
        })
        .then(function (response) {
            toast.success("Chain Updated!");
            setEditedCampaignData({ ...campaignData });
        })
        .catch(function (error) {
            toast.error('Error - ' + error.response.data.message);
            // console.log(error.response)
            // We need to revert the change we made to the chain.
            const campaignData = editedCampaignData;
            chain[chainItemIndex] = originalChainItemData;
            campaignData.chains[currentChainRef.currentIndex] = chain;
            setEditedCampaignData({ ...campaignData });
        });
    }

    const addExistingFeatureToChain = (campaignData, featureId, addToStart) => {
        // for (let i = 0; i < campaignData.features.length; i++) {
            // if (campaignData.features[i].feature.featureType === 'feature') {
                // We have a feature!
                // Do we have a chain for it?
                let featureChain = currentChainRef.current;
                /* for (let j = 0; j < campaignData.chains.length; j++) {
                    if (campaignData.chains[j].indexOf(campaignData.features[i]._id) >= 0) {
                        // We have a chain!
                        if (featureChain === null) {
                            featureChain = campaignData.chains[j];
                        }
                    }
                } */

                if (featureChain) {
                    if (addToStart) {
                        featureChain.splice(0, 0, `${featureId}:${CHAINS_HELPER.START_TYPE_AUTO}:0:${CHAINS_HELPER.END_TYPE_FEATURE_END}`);
                    } else {
                        featureChain.push(`${featureId}:${CHAINS_HELPER.START_TYPE_AUTO}:0:${CHAINS_HELPER.END_TYPE_FEATURE_END}`);
                    }

                    axios
                    .post(updateCampaignRoute, {
                        campaignID: id,
                        campaignName: campaignData.campaignName,
                        campaignTier: campaignData.campaignTier,
                        selectedRegion: campaignData.region,
                        clientName: campaignData.client,
                        adBugCopy: campaignData.adBugCopy,
                        campaignOwner:campaignData.campaignOwnerAccount ? campaignData.campaignOwnerAccount._id : null,
                        sfLink: campaignData.sfLink,
                        sfNumber: campaignData.sfNumber,
                        chains: campaignData.chains,
                    })
                    .then(function (response) {
                        toast.success("Chain Updated!");
                        setEditedCampaignData({ ...campaignData });
                    })
                    .catch(function (error) {
                        toast.error('Error - ' + error.response.data.message);
                        featureChain.splice(featureChain.indexOf(featureId, 1));
                    });
                }
            // }
        // }
    }

    const addNewFeatureChain = () => {
        // add a new blank chain to the campaign data, but only if we don't already have a blank chain.
        const campaignData = campaignContext.campaignData;
        let foundBlankChain = false;
        for (let i = 0; i < campaignData.chains.length; i++) {
            if (campaignData.chains[i].length === 0) {
                foundBlankChain = true;
                break;
            }
        }
        if (!foundBlankChain) {
            campaignData.chains.push([]);
            axios
            .post(updateCampaignRoute, {
                campaignID: id,
                campaignName: campaignData.campaignName,
                campaignTier: campaignData.campaignTier,
                selectedRegion: campaignData.region,
                clientName: campaignData.client,
                adBugCopy: campaignData.adBugCopy,
                campaignOwner:campaignData.campaignOwnerAccount ? campaignData.campaignOwnerAccount._id : null,
                sfLink: campaignData.sfLink,
                sfNumber: campaignData.sfNumber,
                chains: campaignData.chains,
            })
            .then(function (response) {
                toast.success("Feature Chain Added!");
                setEditedCampaignData({ ...campaignData });
            })
            .catch(function (error) {
                toast.error('Error - ' + error.response.data.message);
            });
        }
    }

    const removeFeatureChain = (index) => {
        // remove the chain at the specified index from the campaign data.
        const campaignData = campaignContext.campaignData;
        // if (campaignData.chains[index].length > 0) {
            // We have a chain, let's remove it.
            campaignData.chains.splice(index, 1);
            axios
            .post(updateCampaignRoute, {
                campaignID: id,
                campaignName: campaignData.campaignName,
                campaignTier: campaignData.campaignTier,
                selectedRegion: campaignData.region,
                clientName: campaignData.client,
                adBugCopy: campaignData.adBugCopy,
                campaignOwner:campaignData.campaignOwnerAccount ? campaignData.campaignOwnerAccount._id : null,
                sfLink: campaignData.sfLink,
                sfNumber: campaignData.sfNumber,
                chains: campaignData.chains,
            })
            .then(function (response) {
                toast.success("Feature Chain Removed!");
                setEditedCampaignData({ ...campaignData });
            })
            .catch(function (error) {
                toast.error('Error - ' + error.response.data.message);
            });
        // }
    }

    // Make sure all our features have a stacking order assigned.
    // Not worried about saving this until we make changes because I'll do the same check on the feature page.
    const verifyStacking = (campaignData) => {
        let highestStack = 0;
        for (let i = 0; i < campaignData.features.length; i++) {
            if (typeof campaignData.features[i].stackingOrder !== 'undefined' && campaignData.features[i].stackingOrder > highestStack) {
                highestStack = campaignData.features[i].stackingOrder;
            }
        }
        for (let i = 0; i < campaignData.features.length; i++) {
            if (typeof campaignData.features[i].stackingOrder === 'undefined') {
                highestStack++;
                campaignData.features[i].stackingOrder = highestStack;
            }
        }
    }

    const customisationVars = useRef(null);
    const [gotCustomisation, setGotCustomistation] = useState(false);
    const getCustomisationVars = () => {
        axios
        .get(getCampaignCustomisationVarsRoute, {
            params: { campaignID: id },
            withCredentials:true
        })
        .then(function (response) {
            if (response.data.customisationVars) {
                customisationVars.current = response.data.customisationVars;
                setGotCustomistation(true);
            }
        })
        .catch(function (error) {
            toast.error('Error - ' + error);
        });
    }

    const [featureVars, setFeatureVars] = useState({});
    const featureVarsRef = useRef(null);
    const getFeatureVars = () => {
        axios
        .get(getCampaignFeatureVarsRoute, {
            params: { campaignID: id },
            withCredentials:true
        })
        .then(function (response) {
            if (response.data.streamVars) {
                featureVarsRef.current = response.data.streamVars;
                setFeatureVars(featureVarsRef.current);
            }
        })
        .catch(function (error) {
            toast.error('Error - ' + error);
            // console.log(error.response)
        });
    }
    const updateFeatureVars = (updatedVars, onComplete = null) => {
        axios
        .post(updateCampaignFeatureVarsRoute, {
            campaignID: id, 
            updatedVars: updatedVars,
            withCredentials:true
        })
        .then(function (response) {
            console.log(response.data);
            if (onComplete) {
                onComplete(response.data)
            }
        })
        .catch(function (error) {
            toast.error('Error - ' + error);
        });
    }
    useEffect(() => {
        // These payloads are independent. Starting customisation loading only
        // after feature-vars completed created a long blank interval in the
        // campaign editor on large campaigns.
        getFeatureVars();
        getCustomisationVars();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const [previewMode, setPreviewMode] = useState(false);
    const [previewPostFix, setPreviewPostFix] = useState('');
    const [currentFeature, setCurrentFeature] = useState(null);
    const [showChainsInPreview, setShowChainsInPreview] = useState(false);
    const currentFeatureRef = useRef(null);
    const currentChainRef = useRef(null);
    const [previewFeatureChain, setPreviewFeatureChain] = useState(null);
    const editFeatureSettings = (f, postFix = "", _showChainsInPreview = false, _featureChain = null) => {
        currentFeatureRef.current = f;
        setPreviewPostFix(postFix);
        setCurrentFeature(f);
        setShowChainsInPreview(_showChainsInPreview);
        setPreviewFeatureChain(_featureChain);
        setPreviewMode(true);
    }

    const reportFeatureVarsChanged = (onlyUpdateDisruptor = false, frameId = 'previewFrame') => {
        if (!onlyUpdateDisruptor) {
            updateFeatureVars(featureVarsRef.current.current);
        }
        console.log('Report vars to preview: ', featureVarsRef.current.current[currentFeatureRef.current._id]);
        postMessageToPreviewFrame(POST_MESSAGE_OUT_TYPES.SETTINGS_VARS_RECEIVED, featureVarsRef.current.current[currentFeatureRef.current._id], frameId);
    }

    const reportCustomisationVarsChanged = (updatedVars, featureID) => {

        postMessageToPreviewFrame(
            POST_MESSAGE_OUT_TYPES.CUSTOMISATION_VARS_RECEIVED,
            getPreviewCustomisationVars(currentFeatureRef.current, featureID, id, updatedVars.current[featureID])
        );
         
     }

    /* const [showingRestrictedCustomisationPopup, setShowingRestrictedCustomisationPopup] = useState(false);
    const restrictedCustomisationFeatureId = useRef(null);
    const openRestrictedCustomisationPopup = (featureId) => {
        restrictedCustomisationFeatureId.current = featureId;
        setShowingRestrictedCustomisationPopup(true);
    }
    const closeRestrictedCustomisationPopup = () => {
        setShowingRestrictedCustomisationPopup(false);
    } */

    const [showingFunctionUnavilablePopup, setShowingFunctionUnavilablePopup] = useState(false);
    const openFunctionUnavilablePopup = () => {
        setShowingFunctionUnavilablePopup(true);
    }
    const closeFunctionUnavilablePopup = () => {
        setShowingFunctionUnavilablePopup(false);
    }

    // Special functions that can be triggered by buttons in the feature controls in place of the normal feature commands...
    const BUTTON_FUNCTIONS = {
        reportFeatureVarsChanged: (featureId, param, frameId) => reportFeatureVarsChanged(false, frameId),
        startLivePoll: (featureId, param, frameId) => {
            reportFeatureVarsChanged(false, frameId);
            setTimeout(() => {
                sendFeatureCommand(null, 'START_POLL', featureId, param, frameId);
                // postMessageToPreviewFrame(POST_MESSAGE_OUT_TYPES.COMMAND_RECEIVED, { command: 'START_POLL', extraData: {username:'CampaignStudio', hashtag:'Manual Press', commandParam: param} })
            }, 100);
        },
        createNewLivePoll: (featureId, param, frameId) => {
            // openRestrictedCustomisationPopup(featureId);
            openFunctionUnavilablePopup();
        },
        editRandomizerOptions: (featureId, param, frameId) => {
            openFunctionUnavilablePopup();
        },
        editLiveTextPresets: (featureId, param, frameId) => {
            // openRestrictedCustomisationPopup(featureId);
            openFunctionUnavilablePopup();
        },
        saveLiveTextPreset: (featureId, param, frameId) => {
            // openRestrictedCustomisationPopup(featureId);
            openFunctionUnavilablePopup();
        },
        saveResponseLiveTextPreset: (featureId, param, frameId) => {
            // openRestrictedCustomisationPopup(featureId);
            openFunctionUnavilablePopup();
        },
        selectLiveTextPreset: (featureId, param, frameId) => {
            const _featureVars = featureVarsRef.current.current[featureId];
            const _customisationVars = customisationVars.current.current[featureId];
            console.log('Select live text preset: ', featureId, _featureVars, _customisationVars);

            const presetTextIndex = Number(_featureVars.liveTextControls.presetText);
            const presetTextData = _customisationVars.setup.presetText.presets[presetTextIndex];
            if (presetTextData) {
                _featureVars.liveTextControls.presetName = presetTextData.presetName;
                _featureVars.liveTextControls.headerText = presetTextData.headerText;
                _featureVars.liveTextControls.mainContent = presetTextData.mainContent;
                featureVarsRef.current = {current: {...featureVarsRef.current.current, [featureId]: _featureVars}};
                setFeatureVars(featureVarsRef.current);
                reportFeatureVarsChanged(false, frameId);
            }
        },
        selectResponseLiveTextPreset: (featureId, param, frameId) => {
            const _featureVars = featureVarsRef.current.current[featureId];
            const _customisationVars = customisationVars.current.current[featureId];
            console.log('Select live text preset: ', featureId, _featureVars, _customisationVars);

            const presetTextIndex = Number(_featureVars.responseTextControls.presetText);
            const presetTextData = _customisationVars.setup.presetText.presets[presetTextIndex];
            if (presetTextData) {
                _featureVars.responseTextControls.presetName = presetTextData.presetName;
                _featureVars.responseTextControls.headerText = presetTextData.headerText;
                _featureVars.responseTextControls.mainContent = presetTextData.mainContent;
                featureVarsRef.current = {current: {...featureVarsRef.current.current, [featureId]: _featureVars}};
                setFeatureVars(featureVarsRef.current);
                reportFeatureVarsChanged(false, frameId);
            }
        },
        previewAudio: (featureId, param, frameId) => {
            // console.log('Preview audio: ', featureId, param);
            // Find the srcUrl in the param object. This will be inside another property, which could be called anything.
            let srcUrl = null;
            for (const key in param) {
                if (param[key].srcUrl) {
                    srcUrl = param[key].srcUrl;
                    break;
                }
            }
            if (!srcUrl) {
                console.log('No srcUrl found in param: ', param);
                return;
            }
            LIVE_AUDIO_PREVIEW.playStopAudio(srcUrl);
        },
    }
    const sendFeatureCommand = (e, commandString, featureId, param = null, previewFrameId = null) => {
        if (e?.preventDefault) {
            e.preventDefault();
        }
        if (BUTTON_FUNCTIONS[commandString]) {
            console.log('Running button function: ', commandString, featureId, param, previewFrameId);
            BUTTON_FUNCTIONS[commandString](featureId, param, previewFrameId);
        } else {
            postMessageToPreviewFrame(POST_MESSAGE_OUT_TYPES.COMMAND_RECEIVED, { command: commandString, extraData: {username:'CampaignStudio', hashtag:'Manual Press', commandParam: param} }, previewFrameId ?? 'previewFrame');
        }
    }

    const [showingTooltip, setShowingTooltip] = useState(false);
    const [tooltipText, setTooltipText] = useState('');
    const [tooltipPos, setTooltipPos] = useState({left: 0, bottom: 0});
    const tooltipTimeout = useRef(null);
    const showTooltip = (text, e) => {
        setTooltipPosToMouse(e, true);
        setTooltipText(text);
        if (text.length > 0 && !showingTooltip && tooltipTimeout.current === null) {
            tooltipTimeout.current = setTimeout(() => setShowingTooltip(true), 300);
        }
    }
    const hideTooltip = (e) => {
        clearTimeout(tooltipTimeout.current);
        tooltipTimeout.current = null;
        setShowingTooltip(false);
    }
    const setTooltipPosToMouse = (e, force = false) => {
        if (showingTooltip || force) {
            const toolTipPos = {
                left: e.pageX + 'px',
                bottom: (window.innerHeight - e.pageY + 10) + 'px'
            }
            setTooltipPos(toolTipPos);
        }
    }

    const [analyticsObj, setAnalyticsObj] = useState({});
    
    const [topLevelAnalytics, setTopLevelAnalytics] = useState({});
    const [viewingSessionAnalytics, setViewingSessionAnalytics] = useState(false);
    const [sessionDataToView, setSessionDataToView] = useState(null);
    const [sessionTwitchHandle, setSessionTwitchHandle] = useState(null);

    const openSessionAnalytics = (sessionData, twitchHandle, overallAnalytics) => {
        setAnalyticsObj(sessionData);
        setSessionDataToView(sessionData);
        setViewingSessionAnalytics(true);
        setSessionTwitchHandle(twitchHandle);
        setTopLevelAnalytics(overallAnalytics)
    }
    const closeSessionAnalytics = () => {
        setAnalyticsObj({});
        setViewingSessionAnalytics(false);
    }


    useEffect(
        () => {
            if (editedCampaignData && customisationVars.current) {
                removeUnlinkedChainedFeatures(editedCampaignData, customisationVars.current);
            }
        },
        [editedCampaignData, customisationVars.current]
    )

    const getTabs = () => {
        const tabData = [
            {
                label: 'Content',
            },
            {
                label: 'Campaign Details',
            },
      
            {
                label: 'Streams',
            }
        ];
        if ((gotAnalytics || tab === 'analytics') && authContext.userData.userLevel >= ACCOUNT_TYPES.producer.level) {
            tabData.push({
                label: 'Analytics',
            });
        }
        return tabData;
    }

    const [showArcadeDataPopup, setShowArcadeDataPopup] = useState(false);
    const [defaultArcadeDataFeatureId, setDefaultArcadeDataFeatureId] = useState(null);
    const [defaultArcadeDataStreamId, setDefaultArcadeDataStreamId] = useState(null);
    const openArcadeDataPopup = (featureId = null, streamId = null) => {
        setDefaultArcadeDataFeatureId(featureId);
        setDefaultArcadeDataStreamId(streamId);
        setShowArcadeDataPopup(true);
    }
    const closeArcadeDataPopup = () => {
        setShowArcadeDataPopup(false);
        setDefaultArcadeDataStreamId(null);
    }

    const [chainToDelete, setChainToDelete] = useState(null);
    const deleteFeatureChainConfirmFunc_ref = useRef(null);
    const [showingDeleteChainPopup, setShowingDeleteChainPopup] = useState(false);
    const confirmDeleteChain = (chainLabel, confirmFunc) => {
        console.log('Confirm delete chain: ', chainLabel, confirmFunc);
        setChainToDelete(chainLabel);
        deleteFeatureChainConfirmFunc_ref.current = confirmFunc;
        setShowingDeleteChainPopup(true);
    }

    const [chainItemFeatureToDelete, setChainItemFeatureToDelete] = useState(null);
    const [chainItemIndexToDelete, setChainItemIndexToDelete] = useState(null);
    const deleteFeatureChainItemConfirmFunc_ref = useRef(null);
    const [showingDeleteChainItemPopup, setShowingDeleteChainItemPopup] = useState(false);
    const confirmDeleteChainItem = (feature, chainIndex, chainTitle, confirmFunc) => {
        console.log('Confirm delete chain item: ', feature, chainIndex, confirmFunc);
        setChainItemFeatureToDelete(feature);
        setChainItemIndexToDelete(chainIndex);
        setChainToDelete(chainTitle);
        deleteFeatureChainItemConfirmFunc_ref.current = confirmFunc;
        setShowingDeleteChainItemPopup(true);
    }
    const ChainItemForConfirmDialog = (props) => {
        let boxStyle = props.feature.feature.featureType;
        if (LEFT_COLOR_BLOCK_STYLES[props.feature.feature.featureType + '_' + props.feature.feature.varKey]) {
            boxStyle = props.feature.feature.featureType + '_' + props.feature.feature.varKey;
        }
        if (LEFT_COLOR_BLOCK_STYLES['disruptor_' + props.feature.feature.colourCategory]) {
            boxStyle = 'disruptor_' + props.feature.feature.colourCategory;
        }
        if (LEFT_COLOR_BLOCK_STYLES['category_' + props.feature.feature.colourCategory]) {
            boxStyle = 'category_' + props.feature.feature.colourCategory;
        }

        return (
            <div className="fl-row grow">
                <div className="shrink">
                    <div className="feature-chain-position-holder enabled-chain-position">
                        {props.index + 1}
                    </div>
                </div>
                <LeftColorBlockBox style={boxStyle}>
                    <div className='fl-row list-view-content'>

                        <div>
                            {props.feature.contentLabel}

                            <span className={`bot-time-dark`}>
                                &nbsp;({props.feature.feature.featureName})
                            </span>
                        </div>
                    </div>
                </LeftColorBlockBox>
            </div>
        )
    }

    return (
        <div className={`content-page-container${editMode ? ' edit-mode-bg' : ''}${currentView === 'timeline' ? ' timeline-mode' : ''}`}>
            <div className={`content-page-content-container${currentView === 'timeline' ? ' timeline-mode' : ''}`}>
                <div className={`content-page-main-content${currentView === 'timeline' ? ' no-padding' : ''}`}>
                    {(campaignContext.initialising || !gotCustomisation) &&
                        <div className="initialising-container">
                            <img className="glitch" alt="Twitch Glitch" src={assets.LoadingFeature} />
                        </div>
                    }
                    {!campaignContext.initialising && gotCustomisation &&
                        <>
                            <div className={`campaigns-overview-container${currentView === 'timeline' ? ' timeline-view' : ''}`}>
                                {currentView === 'timeline' ? (
                                    <TimelineEditor 
                                        campaignId={id} 
                                        campaignDataProp={campaignContext.campaignData}
                                        customisationVarsProp={customisationVars.current}
                                    />
                                ) : currentView === 'analytics' ? (
                                    <div className="wide">
                                        <CampaignAnalyticsTab
                                            _openSessionAnalytics={openSessionAnalytics}
                                        />
                                    </div>
                                ) : null}

                            </div>

                            {/* Streams Dropdown */}
                            <StreamsDropdown 
                                isOpen={showStreamsDropdown}
                                onClose={() => setShowStreamsDropdown(false)}
                                campaignId={id}
                                onAddStream={addStream}
                                onEditStream={editStream}
                                editingStreamId={editingStream?._id}
                            />

                            {/* Analytics Dropdown */}
                            <AnalyticsDropdown 
                                isOpen={showAnalyticsDropdown}
                                onClose={() => setShowAnalyticsDropdown(false)}
                                openSessionAnalytics={(sessionData, twitchHandle, overallAnalytics) => {
                                    openSessionAnalytics(sessionData, twitchHandle, overallAnalytics);
                                }}
                            />

                            <ArcadeDataStreamsDropdown
                                isOpen={showArcadeDataDropdown}
                                onClose={() => setShowArcadeDataDropdown(false)}
                                onSelectStream={(streamId) => {
                                    setShowArcadeDataDropdown(false);
                                    openArcadeDataPopup(null, streamId);
                                }}
                            />

                            {/* Campaign Details Popup (compact) */}
                            <CampaignDetailsPop
                                shown={showCampaignDetails}
                                hideFunc={() => { setShowCampaignDetails(false); setCampaignDetailsAnchor(null); }}
                                anchor={campaignDetailsAnchor}
                                onToggleEdit={() => { if (!editMode) { openEditMode({preventDefault:()=>{}}); } else { closeEditMode({preventDefault:()=>{}}); } }}
                                onSave={() => saveEditedCampaignData(null, true, true)}
                                onDiscard={() => closeEditMode({preventDefault:()=>{}})}
                                _editMode={editMode}
                                _editedCampaignData={editedCampaignData}
                                _changeEditedCampaignData={changeEditedCampaignData}
                                _campaignTierData={campaignTierData}
                                _currentRegion={currentRegion}
                                _regionListData={regionListData}
                                _setCurrentRegion={setCurrentRegion}
                                _addProducers={addProducers}
                                _removeProducer={removeProducer}
                                _addClientContacts={addClientContacts}
                                _removeClientContact={removeClientContact}
                                _editCampaignOwner={editCampaignOwner}
                                _lookupAirTable={lookupAirTable}
                                _lookupLoading={salesforceLookupLoading}
                                _lookupResult={salesforceLookupResult}
                                _makeTemplate={makeTemplateFromCampaign}
                            />

                            {showTemplateDetails && (
                                <div className="site-admin-modal-shell">
                                    <div className="site-admin-modal-backdrop" onClick={closeTemplateDetailsPopup} />
                                    <div className="site-admin-modal-card site-admin-modal-card--template-details" onClick={(e) => e.stopPropagation()}>
                                        {currentTemplateDetails || loadingTemplateDetails ? (
                                            loadingTemplateDetails && !currentTemplateDetails ? (
                                                <div className="home-loading-placeholder" />
                                            ) : (
                                                <EditTemplate
                                                    key={currentTemplateDetails?.id || currentTemplateDetails?._id || 'template-details'}
                                                    template={currentTemplateDetails || {}}
                                                    onBack={closeTemplateDetailsPopup}
                                                    onSaved={handleTemplateDetailsSaved}
                                                    showAttachedCampaignPanel={false}
                                                    headerTitle="Edit Template Details"
                                                    isModal={true}
                                                />
                                            )
                                        ) : (
                                            <div className="home-loading-placeholder" />
                                        )}
                                    </div>
                                </div>
                            )}

                            {/* <p>Raw campaign data:</p>
                            {Object.entries(campaignContext.campaignData).map(
                                ([k, v], i) => <p key={k}>{k + ': ' + v}</p>
                            )} */}
                        </>

                    }

                </div>
            </div>
            {showInviteUserPanel &&
                <TabbedInviteUser closePanelFunc={closeInviteUserPanel} campaignId={id} showAcTypeSelector={true} defaultType={acTypeToAdd} acTypeFilter={userFilter} isProducer={isProducerList} />
            }
            {showAddStreamBot &&
                <AddStreamBot closePanelFunc={closeAddStreamBot} campaignId={id} />
            }
            {showEditBot &&
                <EditStreamBot closePanelFunc={closeEditBot} campaignId={id} bot={editingBot} />
            }
            {showRemoveBot &&
                <ConfirmRemoveBot closePanelFunc={closeRemoveBot} campaignId={id} bot={editingBot} />
            }
            {showDuplicateBot &&
                <DuplicateStreamBot closePanelFunc={closeDuplicateBot} campaignId={id} bot={editingBot} />
            }
            {showEditCampaignOwner &&
                <EditCampaignOwner closePanelFunc={closeEditCampaignOwner} owner={campaignContext.campaignData.campaignOwnerAccount} newOwner={editedCampaignData.campaignOwnerAccount} acTypeFilter={userFilters.producer} changeCampaignOwnerFunc={changeCampaignOwner} />
            }

            {showAddStreamChannel &&
                    <AddStreamChannel
                        closePanelFunc={closeAddStreamChannel} 
                        streamID={addChannelStreamID}
                        campaignId={id} 
                    />
                }


            {showAddStream &&
                <AddStream 
                    closePanelFunc={closeAddStream} 
                    campaignId={id}
                    _getProfilePicFunc={getProfilePic}
                />
            }
            {showRemoveStream &&
                <ConfirmRemoveStream 
                    closePanelFunc={closeRemoveStream} 
                    campaignId={id} 
                    stream={editingStream} 
                />
            }
            {showEditStream &&
                <EditStream 
                    closePanelFunc={closeEditStream} 
                    campaignId={id} 
                    stream={editingStream}
                    _getProfilePicFunc={getProfilePic}
                />
            }
            {showAddDistruptor &&
                <AddDisruptor
                    closePanelFunc={closeAddDisruptor} 
                    campaignTier={campaignContext.campaignData.campaignTier}
                    campaignId={id} 
                    addSelectedFeatureToListFunc={addSelectedFeatureToList}
                    addExistingDisruptorToListFunc={(featureId, addToStart) => {addExistingFeatureToChain(campaignContext.campaignData, featureId, addToStart)}}
                    isIntro={addingIntro}
                    isOutro={addingOutro}
                    showSelectExistingOption={addingIntro || addingOutro}
                    campaignFeatures={campaignContext.campaignData.features}
                    addFeatureFromTemplateFunc={addFeatureFromTemplate}
                />
            }
            {showAddFeature &&
                <AddFeature
                    closePanelFunc={closeAddFeature} 
                    campaignId={id} 
                    addSelectedFeatureToListFunc={addSelectedFeatureToList}
                    addFeatureFromTemplateFunc={addFeatureFromTemplate}
                />
            }
            {showAddHashtag &&
                <AddHashtag
                    closePanelFunc={closeAddHashtag} 
                    campaignId={id} 
                    saveHashtag={saveHashtag}
                    feature={editingFeature.current}
                    customisationVars={customisationVars}
                />
            }
            {}
            {showConfirmRemoveFeature &&
                <ConfirmRemoveFeature 
                    feature={currentFeature} 
                    chain={currentChainRef.current}

                    _editedCampaignData={editedCampaignData}
                    _changeEditedCampaignData={changeEditedCampaignData}
                    _saveEditedCampaignData={saveEditedCampaignData}

                    removeFeature={removeSelectedFeatureFromList} 
                    closePanelFunc={closeConfirmRemoveFeature} 
                />
            }
            { showConfirmRemoveQuiz && 
                <ConfirmRemoveQuiz quiz={editingQuiz} removeQuiz={removeQuiz} closePanelFunc={closeConfirmRemoveQuiz} />
            }
            {viewingSessionAnalytics &&
                <SessionAnalytics
                    closePanelFunc={closeSessionAnalytics}
                    _analyticsObj={topLevelAnalytics}
                    _analyticsData={analyticsObj}
                    _updateAnalyticsFunc={setAnalyticsObj}
                    _sessionData={sessionDataToView}
                    _streamData={{}}
                    _campaignData={campaignContext.campaignData}
                    _showTooltip={showTooltip}
                    _hideTooltip={hideTooltip}
                    _sessionTwitchHandle={sessionTwitchHandle}
                />
            }
            {previewMode &&
                <FeaturePreview
                    campaignId={id}

                    currentFeature={currentFeature}
                    titlePostFix={previewPostFix}
                    featureVars={featureVars}
                    customisationVars={customisationVars.current}
                    closeFunc={() => setPreviewMode(false)}

                    showChains={showChainsInPreview}
                    featureChain={previewFeatureChain}

                    startControlsExpanded={currentFeature.feature.featureType === 'feature'}
                    startMaximized={true}
                    resizeable={false}

                    _reportFeatureVarsChanged={reportFeatureVarsChanged}
                    _reportCustomisationVarsChanged={reportCustomisationVarsChanged}

                    _sendFeatureCommandFunc={sendFeatureCommand}
                    _showTooltip={showTooltip}
                    _hideTooltip={hideTooltip}
                />
            }
            {showEditStacking &&
                <EditStackingOrder
                    closePanelFunc={closeEditStacking}
                    features={editedCampaignData.features}
                    saveFeatureUpdates={saveFeatureUpdates}
                />
            }
            {showingTooltip &&
                <div className="tw-tooltip" style={tooltipPos} dangerouslySetInnerHTML={{__html: tooltipText}}>
                </div>
            }
            {showArcadeDataPopup &&
                <ArcadeDataPopup closePanelFunc={closeArcadeDataPopup} featureId={defaultArcadeDataFeatureId} streamId={defaultArcadeDataStreamId} autoFetchOnOpen={Boolean(defaultArcadeDataStreamId)} />
            }
            {/* showingRestrictedCustomisationPopup &&
                <RestrictedCustomisationPopup
                    title="Edit Poll Data"
                    tab="setup"
                    group="pollData"
                    family="polls"
                    closePanelFunc={closeRestrictedCustomisationPopup}
                    featureId={restrictedCustomisationFeatureId.current}
                    campaignData={editedCampaignData}
                    customisationVars={customisationVars.current}
                    saveCustomisationVars={reportCustomisationVarsChanged}
                />
            */}
            {showingFunctionUnavilablePopup &&
                <FunctionUnavailableInPreviewPopup
                    closePanelFunc={closeFunctionUnavilablePopup}
                />
            }
            {showingDeleteChainPopup &&
                <ConfirmationDialog
                    showCloseBtn={false}
                    closePanelFunc={null}
                    confirmFunc={() => {
                        deleteFeatureChainConfirmFunc_ref.current();
                        setShowingDeleteChainPopup(false);
                    }}
                    cancelFunc={() => setShowingDeleteChainPopup(false)}
                    wide={false}
                    confirmButtonLabel="REMOVE IT!"
                >
                    <div className="fl-column">
                        <h3 className="j-center">Are you sure you want to remove this feature chain?</h3>
                        <h2 className="j-center success-color">{chainToDelete}</h2>
                    </div>
                </ConfirmationDialog>
            }
            {showingDeleteChainItemPopup &&
                <ConfirmationDialog
                    showCloseBtn={false}
                    closePanelFunc={null}
                    confirmFunc={() => {
                        deleteFeatureChainItemConfirmFunc_ref.current();
                        setShowingDeleteChainItemPopup(false);
                    }}
                    cancelFunc={() => setShowingDeleteChainItemPopup(false)}
                    wide={false}
                    confirmButtonLabel="REMOVE IT!"
                >
                    <div className="fl-column">
                        <h3 className="j-center">Are you sure you want to remove this step from the chain?</h3>
                        <div className="fl-column compact">
                            <h2 className="j-center success-color standard-rem-top-bot-margin">{chainToDelete}</h2>
                            <div className="double-bot-margin">
                                <ChainItemForConfirmDialog feature={chainItemFeatureToDelete} index={chainItemIndexToDelete} />
                            </div>
                        </div>
                    </div>
                </ConfirmationDialog>
            }
            <ScreenRecorderPop 
                shown={showScreenRecorderPop} 
                hideFunc={() => setShowScreenRecorderPop(false)} 
                reportRecordingFunc={() => {}}
            />
        </div>
    );

}
export default CampaignOverview;
